import { DUTCH_TOUR_STORIES } from './tourStoryTranslations';
import { DUTCH_SOURCE_NOTES } from '../history/sources';
import { CITY_INTRODUCTION } from '../history/cityIntroduction';
import { DUTCH_DISCOVERIES } from '../discovery/discoveryTranslations';
import { DUTCH_QUESTIONS } from '../discovery/questions';

export type Language = 'en' | 'nl';
const DUTCH: Record<string, string> = {
  Library: 'Bibliotheek',
  'Reference library': 'Bronnenbibliotheek',
  ' visitors online': ' bezoekers online',
  ' visitor count unavailable': ' aantal bezoekers niet beschikbaar',
  'Visitors online · refreshes every 5 seconds': 'Bezoekers online · ververst elke 5 seconden',
  'Live visitor count is unavailable · retries every 5 seconds':
    'Aantal bezoekers niet beschikbaar · probeert elke 5 seconden opnieuw',
  'Touch controls': 'Aanraakbediening',
  'Move left': 'Naar links bewegen',
  'Move right': 'Naar rechts bewegen',
  'Fly higher': 'Hoger vliegen',
  'Fly lower': 'Lager vliegen',
  'Behind the visitor view': 'Van achter de bezoeker',
  'Hold the arrows to move. Swipe the scene to look around. Run changes your pace. Menu opens settings and tours.':
    'Houd de pijlen ingedrukt om te bewegen. Veeg over de stad om rond te kijken. Rennen verandert je tempo. Menu opent instellingen en rondleidingen.',
  'Board boat': 'In de boot',
  'Step ashore': 'Aan land',
  'Close help': 'Hulp sluiten',
  'Send message': 'Bericht versturen',
  'Close conversation': 'Gesprek sluiten',
  Chat: 'Gesprek',
  Boost: 'Versnellen',
  'Pull hard': 'Harder roeien',
  Up: 'Omhoog',
  Down: 'Omlaag',
  [CITY_INTRODUCTION.en]: CITY_INTRODUCTION.nl,
  'A city becoming a world harbour': 'Van vestingstad naar wereldhaven',
  Low: 'Laag',
  Medium: 'Gemiddeld',
  High: 'Hoog',
  Transition: 'Overgang',
  "Painter's view": 'Gezichtspunt van de schilder',
  'Click or drag to look around': 'Klik of sleep om rond te kijken',
  'Drag to look around': 'Sleep om rond te kijken',
  'Press H or Esc to close help': 'Druk op H of Esc om de hulp te sluiten',
  'Run / Pull hard (boat)': 'Rennen / Harder roeien',
  Online: 'Verbonden',
  'Run / Row harder': 'Rennen / Harder roeien',
  'Change view (V)': 'Wissel aanzicht (V)',
  'Change city time': 'Stadstijd aanpassen',
  'Close tours': 'Rondleidingen sluiten',
  'Tour speed': 'Snelheid rondleiding',
  'Tour playback': 'Rondleiding afspelen',
  'Tour position': 'Positie in rondleiding',
  'Pause tour': 'Rondleiding pauzeren',
  'Resume tour': 'Rondleiding hervatten',
  'Restart tour': 'Rondleiding herstarten',
  'Take over': 'Zelf verdergaan',
  'Sound on': 'Geluid aan',
  'Sound off': 'Geluid uit',
  'Mute sound': 'Geluid dempen',
  'Enable sound': 'Geluid inschakelen',
  Connecting: 'Verbinden',
  'City reconnecting': 'Stad opnieuw verbinden',
  'City connection unavailable': 'Geen verbinding met de stad',
  retrying: 'opnieuw proberen',
  'City assets changed': 'Stadsbestanden gewijzigd',
  'reload to reconnect': 'herlaad om opnieuw te verbinden',
  'Painting minimap': 'Minikaart van het schilderij',
  'Your position and direction in the painting': 'Je positie en richting op het schilderij',
  'Minimize painting minimap': 'Minikaart verkleinen',
  'Show painting minimap': 'Minikaart tonen',
  'Recenter painting on your position': 'Schilderij op je positie centreren',
  'Zoom out of painting': 'Schilderij uitzoomen',
  'Zoom into painting': 'Schilderij inzoomen',
  'Explore painting: drag or use arrow keys to pan':
    'Verken het schilderij: sleep of gebruik de pijltjestoetsen',
  'Drag to explore the painting; recenter to follow your position':
    'Sleep om het schilderij te verkennen; centreer om je positie te volgen',
  'Loading data...': 'Gegevens laden…',
  'Show / hide visitor names': 'Namen van bezoekers tonen / verbergen',
  'Choose your citizen': 'Kies je stadsgenoot',
  'City register': 'Stadsregister',
  'Nearby conversation': 'Gesprekken om je heen',
  'Nearby conversation (Enter)': 'Gesprekken om je heen (Enter)',
  'Speak to a townsperson (Shift+Enter)': 'Spreek een stadsgenoot aan (Shift+Enter)',
  'Conversation with a townsperson': 'Gesprek met een stadsgenoot',
  'Around you': 'Om je heen',
  Farewell: 'Tot ziens',
  'Public conversation in this part of the city.': 'Openbare gesprekken in dit deel van de stad.',
  'Your words': 'Jouw woorden',
  Whisper: 'Fluisteren',
  Follow: 'Volgen',
  Mute: 'Dempen',
  Unmute: 'Dempen opheffen',
  'Selected visitor': 'Geselecteerde bezoeker',
  Gestures: 'Gebaren',
  'Gestures (J)': 'Gebaren (J)',
  'Choose a gesture': 'Kies een gebaar',
  Wave: 'Zwaaien',
  Curtsy: 'Nijging',
  Bow: 'Buigen',
  'Heel click': 'Hakken klikken',
  'Hats off': 'Hoed af',
  'M’lady': 'Mijn vrouwe',
  Avast: 'Halt!',
  'Let the gesture finish.': 'Laat het gebaar afmaken.',
  'Waiting for the city…': 'Wachten op de stad…',
  'Wait for the city to confirm your gesture.': 'Wacht tot de stad je gebaar bevestigt.',
  'The city did not confirm your gesture.': 'De stad heeft je gebaar niet bevestigd.',
  'This gesture is unavailable for your citizen.':
    'Dit gebaar is niet beschikbaar voor je stadsgenoot.',
  'Your citizen wears a hood, not a removable hat.':
    'Je stadsgenoot draagt een kap die niet kan worden afgenomen.',
  'This visitor has left the city.': 'Deze bezoeker heeft de stad verlaten.',
  'Wait for the city to confirm this change.': 'Wacht op de bevestiging van de stad.',
  'The city did not confirm this change.': 'De stad heeft deze wijziging niet bevestigd.',
  Speak: 'Spreek',
  'Say it together': 'Samen op pad',
  'Shall we explore together?': 'Zullen we samen op ontdekking gaan?',
  'Where is the fish market?': 'Waar is de vismarkt?',
  'Meet me on the Dam!': 'Tot zo op de Dam!',
  'Sending…': 'Verzenden…',
  'Historical source': 'Historische bron',
  'Write one line of up to 80 characters.': 'Schrijf één regel van maximaal 80 tekens.',
  'The city is reconnecting. Your words have not been sent.':
    'De stad verbindt opnieuw. Je woorden zijn niet verzonden.',
  'Wait for your last message to reach the city.':
    'Wacht tot je vorige bericht de stad heeft bereikt.',
  'The city did not acknowledge your message.': 'De stad heeft je bericht niet bevestigd.',
  'The connection closed before your message was confirmed.':
    'De verbinding sloot voordat je bericht werd bevestigd.',
  'Allow a moment between messages.': 'Laat even tijd tussen je berichten.',
  'Your words could not reach the city.': 'Je woorden konden de stad niet bereiken.',
  'The shared city is not connected.': 'Er is geen verbinding met de gedeelde stad.',
  'Talk to a townsperson': 'Spreek een stadsgenoot aan',
  'Speak to nearby visitors': 'Spreek met bezoekers in de buurt',
  'Choose a name from the city register': 'Kies een naam uit het stadsregister',
  'Choose another name': 'Kies een andere naam',
  'Step into Amsterdam': 'Stap Amsterdam binnen',
  Male: 'Man',
  Female: 'Vrouw',
  Name: 'Naam',
  Clothing: 'Kleding',
  'Explore on your own': 'Verken op eigen gelegenheid',
  'Join the shared city': 'Bezoek de gedeelde stad',
  'Sign in to join the shared city.': 'Log in om de gedeelde stad te bezoeken.',
  'Exploring on your own': 'Op eigen gelegenheid',
  Russet: 'Roodbruin',
  'Woad blue': 'Wede blauw',
  'Madder red': 'Meekrap rood',
  'Moss green': 'Mosgroen',
  'Weld yellow': 'Reseda geel',
  Charcoal: 'Antraciet',
  'Loading...': 'Laden…',
  Ready: 'Gereed',
  Close: 'Sluiten',
  Walking: 'Lopen',
  Flying: 'Vliegen',
  Rowing: 'Roeien',
  Boat: 'Boot',
  'Behind the visitor': 'Achter de bezoeker',
  'First-person view': 'Vanuit eigen ogen',
  Tours: 'Rondleidingen',
  Movement: 'Beweging',
  'Movement keys': 'Bewegingstoetsen',
  'Left handed': 'Linkshandig',
  'Left Shift': 'Linker Shift',
  'Right Shift': 'Rechter Shift',
  'Turn left': 'Naar links draaien',
  'Turn right': 'Naar rechts draaien',
  'Run / Boost': 'Rennen / Versnellen',
  'Reset movement keys': 'Bewegingstoetsen herstellen',
  'Press a key': 'Druk op een toets',
  'Keys saved': 'Toetsen opgeslagen',
  'This key is reserved. Choose another key.': 'Deze toets is gereserveerd. Kies een andere toets.',
  'This key is already assigned. Choose another key.':
    'Deze toets is al toegewezen. Kies een andere toets.',
  'These keys could not be saved in this browser.':
    'Deze toetsen konden niet worden opgeslagen in deze browser.',
  'Left mouse drag': 'Sleep met linkermuisknop',
  'Look around without turning the visitor': 'Kijk rond zonder de bezoeker te draaien',
  'Turn the visitor and camera': 'Draai de bezoeker en de camera',
  'Both mouse buttons': 'Beide muisknoppen',
  'Move forward and steer': 'Loop vooruit en stuur',
  'Turn, or strafe while holding right mouse':
    'Draai, of loop zijwaarts met de rechtermuisknop ingedrukt',
  'Zoom behind view / adjust fly speed': 'Zoom achteraanzicht / pas vliegsnelheid aan',
  'Zoom behind view': 'Zoom achteraanzicht',
  View: 'Beeld',
  Interface: 'Bediening',
  'Move forward': 'Vooruit lopen',
  'Move backward': 'Achteruit lopen',
  'Strafe left': 'Naar links lopen',
  'Strafe right': 'Naar rechts lopen',
  'First-person / behind the visitor view': 'Wissel tussen eigen ogen en achter de bezoeker',
  'Right mouse drag': 'Sleep met rechtermuisknop',
  'Rotate around yourself in behind view': 'Draai rond jezelf in de achteraanzichtstand',
  'Run (walk) / Boost (fly) / Pull hard (boat)': 'Rennen / Sneller vliegen / Harder roeien',
  'In the boat: row ahead / astern, turn the bow': 'In de boot: vooruit / achteruit roeien, sturen',
  'Ascend (fly mode)': 'Omhoog vliegen',
  'Descend (fly mode)': 'Omlaag vliegen',
  'Adjust fly speed': 'Vliegsnelheid aanpassen',
  Scroll: 'Scrollen',
  'Toggle walk/fly mode': 'Wissel tussen lopen en vliegen',
  'Board the rowing boat / step ashore': 'Stap in de roeiboot / aan wal',
  "Fly to painter's view": 'Vlieg naar het gezichtspunt van de schilder',
  'Toggle painting overlay': 'Schilderij over het beeld tonen / verbergen',
  'Toggle painting minimap (− / + to zoom)': 'Minikaart tonen / verbergen (− / + om te zoomen)',
  Help: 'Hulp',
  Settings: 'Instellingen',
  'Close settings': 'Instellingen sluiten',
  Graphics: 'Beeldkwaliteit',
  'Graphics: Low': 'Beeldkwaliteit: Laag',
  'Graphics: Medium': 'Beeldkwaliteit: Gemiddeld',
  'Graphics: High': 'Beeldkwaliteit: Hoog',
  'Cycle quality tier': 'Beeldkwaliteit wisselen',
  'Show / hide coordinates (x, y, height, yaw, pitch)':
    'Coördinaten tonen / verbergen (x, y, hoogte, draaiing, helling)',
  'Choose a tour': 'Kies een rondleiding',
  'Pause / Resume tour': 'Rondleiding pauzeren / hervatten',
  'Toggle this help': 'Deze hulp tonen / verbergen',
  'Open city menu / Close modal': 'Stadsmenu openen / Venster sluiten',
  'Return to the city': 'Terug naar de stad',
  'Drag to change time': 'Sleep om de tijd te veranderen',
  'Shared city time': 'Tijd van de gedeelde stad',
  'Return to live city time': 'Terug naar de actuele stadstijd',
  'Loading painting…': 'Schilderij laden…',
  'Painting unavailable': 'Schilderij niet beschikbaar',
  Pause: 'Pauzeren',
  Resume: 'Hervatten',
  Stop: 'Stoppen',
  Connected: 'Verbonden',
  'Connecting…': 'Verbinden…',
  'Reconnecting…': 'Opnieuw verbinden…',
  'Press H for help': 'Druk op H voor hulp',
  'Click to look around': 'Klik om rond te kijken',
  'Fly over Amsterdam': 'Vlieg over Amsterdam',
  'Walk the Dam': 'Wandel over de Dam',
  'Churches and chapels': 'Kerken en kapellen',
  'Boat on the Damrak': 'Vaar over het Damrak',
  Account: 'Account',
  'Sign in': 'Inloggen',
  'Sign out': 'Uitloggen',
  'Create an account': 'Account aanmaken',
  'Create account': 'Account aanmaken',
  'Check your email': 'Kijk in je e-mail',
  'Email address': 'E-mailadres',
  Password: 'Wachtwoord',
  'Code from the email': 'Code uit de e-mail',
  Confirm: 'Bevestigen',
  'Send a new code': 'Stuur een nieuwe code',
  'Forgot your password?': 'Wachtwoord vergeten?',
  'Signed in as': 'Ingelogd als',
  'We sent a code to your email address. Enter it here to finish.':
    'We hebben een code naar je e-mailadres gestuurd. Vul die hier in om af te ronden.',
  'No account yet? Create one': 'Nog geen account? Maak er een aan',
  'Already have an account? Sign in': 'Heb je al een account? Log in',
  'A new code is on its way.': 'Er is een nieuwe code onderweg.',
  'Fill in this field.': 'Vul dit veld in.',
  'The city register cannot be reached. Try again in a moment.':
    'Het stadsregister is niet bereikbaar. Probeer het zo opnieuw.',
  'Too many tries. Wait a few minutes and try again.':
    'Te vaak geprobeerd. Wacht een paar minuten en probeer het opnieuw.',
  'This code has expired. Sign in again to get a new one.':
    'Deze code is verlopen. Log opnieuw in voor een nieuwe code.',
  'The password needs at least 8 characters.': 'Het wachtwoord moet minstens 8 tekens hebben.',
  'This password is too common. Choose another.':
    'Dit wachtwoord komt te vaak voor. Kies een ander.',
  'The password cannot be only numbers.': 'Het wachtwoord mag niet alleen uit cijfers bestaan.',
  'The password is too much like the email address.':
    'Het wachtwoord lijkt te veel op het e-mailadres.',
  'The email address or password is not right.': 'Het e-mailadres of wachtwoord klopt niet.',
  'That code is not right. Check the email and try again.':
    'Die code klopt niet. Kijk in de e-mail en probeer het opnieuw.',
  'Enter a valid email address.': 'Vul een geldig e-mailadres in.',
};
let language: Language = 'en';
try {
  language = localStorage.getItem('ams1538.language') === 'nl' ? 'nl' : 'en';
} catch {
  /* Storage is optional in private browsing. */
}
const bindings = new Set<{ node: WeakRef<Text>; source: string }>();
const byNode = new WeakMap<Text, { node: WeakRef<Text>; source: string }>();
const attributes = new Set<{ node: WeakRef<Element>; attribute: string; source: string }>();
const attributeNodes = new WeakMap<
  Element,
  Map<string, { node: WeakRef<Element>; attribute: string; source: string }>
>();
export function setLabel(node: Element, attribute: string, source: string): void {
  const map = attributeNodes.get(node) ?? new Map();
  const binding = map.get(attribute) ?? { node: new WeakRef(node), attribute, source };
  binding.source = source;
  map.set(attribute, binding);
  attributeNodes.set(node, map);
  attributes.add(binding);
  node.setAttribute(attribute, translate(source));
}
const listeners = new Set<() => void>();
export function translate(source: string, locale: Language = language): string {
  if (locale === 'en') return source;
  if (DUTCH[source]) return DUTCH[source];
  if (DUTCH_TOUR_STORIES[source]) return DUTCH_TOUR_STORIES[source];
  if (DUTCH_SOURCE_NOTES[source]) return DUTCH_SOURCE_NOTES[source];
  if (DUTCH_DISCOVERIES[source]) return DUTCH_DISCOVERIES[source];
  if (DUTCH_QUESTIONS[source]) return DUTCH_QUESTIONS[source];
  if (source.includes(' · '))
    return source
      .split(' · ')
      .map((part) => translate(part, locale))
      .join(' · ');
  const time = source.match(
    /^(\d{2}:\d{2}), (shared city time|current Amsterdam time|selected time)$/
  );
  if (time)
    return `${time[1]}, ${{ 'shared city time': 'tijd van de gedeelde stad', 'current Amsterdam time': 'actuele Amsterdamse tijd', 'selected time': 'gekozen tijd' }[time[2] ?? '']}`;
  return source.replace(/(\d+) visitors?/g, '$1 bezoekers');
}
export function bindText(node: Text, source: string): void {
  const binding = byNode.get(node) ?? { node: new WeakRef(node), source };
  binding.source = source;
  byNode.set(node, binding);
  bindings.add(binding);
  node.data = translate(source);
}
export function currentLanguage(): Language {
  return language;
}
export function onLanguageChange(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
export function setLanguage(value: Language): void {
  language = value;
  document.documentElement.lang = value;
  try {
    localStorage.setItem('ams1538.language', value);
  } catch {
    /* Storage is optional in private browsing. */
  }
  for (const binding of bindings) {
    const node = binding.node.deref();
    if (node) node.data = translate(binding.source);
    else bindings.delete(binding);
  }
  for (const binding of attributes) {
    const node = binding.node.deref();
    if (node) node.setAttribute(binding.attribute, translate(binding.source));
    else attributes.delete(binding);
  }
  for (const listener of listeners) listener();
}
